const PAGE_NAME = 'virtual kitchen';
const COLLECTION = process.env.COLLECTION_NAME.toLowerCase();

const parseCategory = function ( section )
{
  return `${ PAGE_NAME } ${ COLLECTION } - ${ section }`.toLowerCase();
};

export const sendEvent = ( section, action, label = undefined, value = undefined ) =>
{
  section = ( typeof action === "string" ) ? section.toLowerCase() : section;
  action = ( typeof action === "string" ) ? action.toLowerCase() : action;
  label = ( typeof label === "string" ) ? label.toLowerCase() : label;

  let category = parseCategory( section );

  if ( process.env.NODE_ENV === "development" )
  {
    console.log( 'EVENT |', `category: ${ category } |`, `action: ${ action } |`, `label: ${ label }` );
  }

  //GTM: Generic
  // gtag( "event", 'ga_event', {
  //   eventAction: action,
  //   eventCategory: category,
  //   eventLabel: label,
  //   eventValue: value
  // } );

  //GA UA (analytics.js):
  if(typeof ga !== 'undefined')
  {
    if ( process.env.NODE_ENV === "development" ) {
      console.log("GA Exists")
    }
    ga('send', 'event', category, action, label, value );
  }

  //GA4 (legacy):
  if(typeof gtag !== 'undefined')
  {
    if ( process.env.NODE_ENV === "development" ) {
      console.log("gtag Exists")
    }
    gtag('event', action, {
      category: category,
      label: label,
      value: value
    });
  }

    //GA UA (gtag.js):
    // if(typeof gtag !== 'undefined') {
    //   gtag('send', 'event', action {
    //     event_category: category,
    //     event_label: label,
    //     event_value: value
    //   });
    // }


  //GA4 (modern):
  // if(typeof gtag !== 'undefined') {
  //   gtag('event', action, {
  //     page: PAGE_NAME,
  //     section: section,
  //     collection: COLLECTION,
  //     label: label,
  //     value: value
  //   });
  // }
};
